import React from 'react'
import { StyledContainer } from './styled/index'
import { refs } from '../../../hocs/withRefsStore'

const Container = ({ nodeName, ...props }) => (
  <StyledContainer ref={refs.store(nodeName)} {...props} />
)

export default Container
